 function Subtitle({styleClass, style, children}){
    return(
        <div style={style} className={`text-xl font-semibold ${styleClass}`}>{children}</div>
    )
}

export default Subtitle